export enum ServiceLanguages {
  Italian = 'it'
}
